(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-back-link"]) return;
  try {
    
  if (!customElements.get('back-to-collection')) {
    class BackToCollection extends HTMLElement {
      connectedCallback() {
        const link = this.querySelector('[data-back-link]');
        const label = this.querySelector('[data-back-label]');
        const optionsElement = this.querySelector('[data-collection-options]');

        if (!link || !label || !optionsElement) return;

        let collections = [];

        try {
          collections = JSON.parse(optionsElement.textContent);
        } catch (error) {
          return;
        }

        if (!Array.isArray(collections) || collections.length === 0) return;

        const candidates = [];

        try {
          const currentUrl = new URL(window.location.href);
          const referrerUrl = document.referrer ? new URL(document.referrer) : null;
          candidates.push(currentUrl);

          if (referrerUrl && referrerUrl.origin === currentUrl.origin) {
            candidates.push(referrerUrl);
          }
        } catch (error) {
          return;
        }

        const matchingCollection = collections.find((item) => {
          return candidates.some((candidate) => {
            return candidate.pathname === item.url
              || candidate.pathname.startsWith(`${item.url}/`);
          });
        });

        if (!matchingCollection) return;

        link.href = matchingCollection.url;
        link.setAttribute('aria-label', matchingCollection.title);
        label.textContent = matchingCollection.title;
      }
    }

    customElements.define('back-to-collection', BackToCollection);
  }

  } catch(e) { console.error(e); }
})();
})();
